import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const
};

export const MenuIcon = createSvgIcon(
  <>
    <path d="M0.9 0.900024H18.3983M0.9 6.21326H15.3104M0.9 11.5265H18.3983" {...strokeProps} />
  </>,
  { displayName: 'MenuIcon', viewBox: '0 0 20 13' }
);
